// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Services_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/services/remover
 *
 * Deletes a service by ID.
 */
import { registerContract } from './validate'

export interface Services_RemoverInput {
so_service_id: number
}

registerContract('Services_RemoverInput', {
  so_service_id: { type: 'number',  required: true },
})
